document.addEventListener("DOMContentLoaded", function() {
    setTimeout(function() {
        let loader = document.getElementById("custom-loader");
        if (loader) {
            loader.style.display = "none";
        }
    }, 2600);
});
